module.exports = __webpack_public_path__ + "media/application/images/ui/icon-yes-tick-0f4213c51800c07e11e52394bf4e9e99.png";